import React, { useEffect, useState } from "react"
import { Card, Container } from "react-bootstrap"
import { parsedUser } from "../../common/GetCurrentUser"
import API from "../../common/API"
import { useTranslation } from "react-i18next"

interface Visit {
  id: string
  name: string
  address: string
  sector: string
  city: string
  creditCode: string
  visitCount: number
}

export default function VisitReportContainer() {
  const [visits, setVisits] = useState<Visit[]>([])
  const { t } = useTranslation("global");
  const user = parsedUser()
  const bindData = async () => {
    console.log(user)
    const request = await API.getAction(
      "placeVisit/VisitSummary?OrganizationId=" + user.OrganizationId
    )
    if (request.data.status === "ok") {
      setVisits(request.data.response)
    }
  }
  useEffect(() => {
    bindData()
  }, [])
  return (
    <Container fluid>
      <Card className="my-4">
        <Card.Header>
          <Card.Title>{t("Visit Report")}</Card.Title>
        </Card.Header>
        <Card.Body>
          <table className="table table-striped">
            <thead>
              <tr>
                <th>#</th>
                <th>{t("Place")}</th>
                <th>{t("Credit Code")}</th>
                <th>{t("Visits")}</th>
              </tr>
            </thead>
            <tbody>
              {visits.map((visit, index) => {
                return (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>
                      <a href={`/places/${visit.id}`}>{visit.name}</a>
                      <br />
                      <small>{`${visit.address} ${visit.sector} ${visit.city}`}</small>
                    </td>
                    <td className="text-uppercase">{visit.creditCode}</td>
                    <td>{visit.visitCount}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </Card.Body>
      </Card>
    </Container>
  )
}
